module.exports = __webpack_public_path__ + "img/99.d8173dff.jpg";